import React, { useRef, useState } from "react";
import DashboardSideBar from "./DashboardSideBar";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import DashboardSideBarDrawer from "./DashboardSideBarDrawer";
import { useDashboardSideBar } from "../../Context/DashboardSideBarContext/DashboardSideBarContext";
import { Outlet } from "react-router-dom";
import useAccess from "../../Hooks/useAccess";
import "./index.scss";

const Dashboard: React.FC = () => {
  const { isOpen, toggleSideBar } = useDashboardSideBar();
  const dashboardRef = useRef<HTMLDivElement>(null);
  const [collapsed, setCollapsed] = useState(false);
  const { currentPlan } = useAccess();

  const isFreePlan = currentPlan && currentPlan.type === "free";

  const handleToggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  const handleBookSession = () => {
    window.open("https://calendar.app.google/Pjnun8VeriMgN9H89", "_blank");
  };

  return (
    <section className="dashboard-container" ref={dashboardRef}>
      <div className="dashboard-sider">
        <DashboardSideBar
          collapsed={collapsed}
          isSidebarOpen={isOpen}
          handleBookSession={handleBookSession}
        />
        <div className="dashboard-sider-toggle-section">
          {isFreePlan && (
            <div
              className="dashboard-sider-onboarding-help-section"
              style={{ display: collapsed ? "none" : "flex" }}
            >
              <small style={{}}>
                Need help with your onboarding? Book a free session with our
                team.
              </small>
              <Button
                size="small"
                type="primary"
                block
                onClick={handleBookSession}
              >
                Book Now
              </Button>
            </div>
          )}
          <Button
            type="text"
            block
            icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
            onClick={handleToggleCollapse}
          />
        </div>
      </div>
      <div className="dashboard-content hide-scroll-bar">
        <Outlet />
      </div>
      <DashboardSideBarDrawer
        isOpen={isOpen}
        onClose={toggleSideBar}
        dashboardRef={dashboardRef}
        handleBookSession={handleBookSession}
      />
    </section>
  );
};

export default Dashboard;
